<template>
  <div v-for="(futureChange, itemIndex) in insurancePolicy.futureChanges" :key="itemIndex">
    <div class="w-full">
      <span
        class="text-racq-dark-grey text-m pr-1"
        v-html="replaceBookmarks(futureChange, item?.firstLinkCompanionContent?.value)"
      ></span>
      <span>
        <a
          v-if="futureChange?.documentId"
          @click="downloadDocument(futureChange?.documentId)"
          class="text-base inline cursor-pointer"
          v-html="replaceBookmarks(futureChange, item.firstLinkContent.value)"
        ></a>
      </span>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { FutureChange, InsurancePolicy } from '@/interfaces';
import { replaceBookmark } from '@/utils/bookmark.replace';
import { formatDate } from 'date-fns';
import {
  getPolicyStatusDetails,
  IInsurancePolicyStatusRules,
} from '@/utils/self-service-rules/InsurancePolicyStatusRules';
import { SelfServiceService } from '@/services/store';
import { LONG_MONTH_DATE } from '@/constants/formats';
const policyStatusRules = ref<IInsurancePolicyStatusRules>();

enum Bookmarks {
  futureChangeEffectiveDate = 'futureChange.effectiveDate',
}

const props = defineProps<{
  insurancePolicy: InsurancePolicy;
  item: any;
}>();

onMounted(async () => {
  policyStatusRules.value = await getPolicyStatusDetails(props.insurancePolicy, new Date(), false);
});

const replaceBookmarks = (futureChange: FutureChange, content: string) => {
  if (futureChange.effectiveDate) {
    content = replaceBookmark(
      Bookmarks.futureChangeEffectiveDate,
      content,
      formatDate(new Date(futureChange.effectiveDate), LONG_MONTH_DATE)
    );
  }

  //If no document replace this content.
  if (!futureChange?.documentId) {
    content = content.replace('View your', '');
  }

  return content;
};

const downloadDocument = async (documentId: string) => {
  if (!documentId) return;

  try {
    const response = await SelfServiceService.getDownloadDocument(documentId);
  } catch (error) {
    alert(`Download${documentId}${error}`);
  }
};
</script>
